import * as React from 'react';
import { getColorValue } from '../utilities/color';

function AllCanEdit(props) {
  const gray = getColorValue('illustrationGray');
  const accent = getColorValue('illustrationAccentGray');
  const stroke = getColorValue('illustrationStroke');
  const blue = getColorValue('illustrationAccent');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m149.5 171.824c-22.25 0-39.2-11.52-46.52-31.65-1.28-3.47-2.27-7.25-2.95-11.22-.69-4.03-1.03-7.97-1-11.71.17-21.5497 12.4-38.1497 33.54-45.5397 3.65-1.28 7.53-2.28 11.51-2.96 3.78-.67 7.61-1.02 11.36-1.07 22.37-.23 39.49 11.33 46.9 31.71 1.3 3.5897 2.3 7.4097 2.98 11.3697.63 3.63.97 7.23 1 10.72l.02.02v.83c-.14 21.67-12.37 38.3-33.57 45.61-3.48 1.21-7.21 2.16-11.06 2.82-4 .69-7.98 1.05-11.83 1.07-.12 0-.25 0-.37 0zm6.57-100.1497c-.2 0-.39 0-.59 0-3.54.04-7.14.38-10.72 1-3.77.65-7.43 1.59-10.87 2.8-19.74 6.9-30.7 21.75-30.86 41.7997-.03 3.51.29 7.21.94 11 .64 3.74 1.57 7.28 2.77 10.53 6.85 18.84 22.15 29.15 43.11 29.02 3.63-.02 7.39-.36 11.17-1.01 3.64-.62 7.15-1.52 10.43-2.66 19.32-6.66 30.54-21.69 30.87-41.29v-.57c.02-3.51-.3-7.16-.94-10.85-.64-3.74-1.58-7.33-2.8-10.69-6.73-18.4997-22.21-29.0697-42.51-29.0697z"
        fill={gray}
      />
      <path
        d="m211.38 172.104c.28-1.68.41-3.47.38-5.36-.03-1.92-.21-3.72-.54-5.42-1.96-10.09-9.07-16.23-18.95-17.7-1.69-.25-3.45-.37-5.29-.34-1.91.03-3.75.2-5.49.52-9.84 1.78-16.77 8.1-18.45 18.18-.28 1.7-.42 3.52-.39 5.43s.21 3.67.53 5.35c1.95 10.02 9.05 16.16 18.95 17.67 1.75.27 3.59.39 5.5.37 1.83-.03 3.6-.19 5.27-.49 9.85-1.74 16.8-8.09 18.46-18.21z"
        fill={gray}
      />
      <path
        d="m201.47 185.445c.2-11.21-5.47-15.38-14.14-15.23-8.14.14-13.53 4.51-13.34 15.71l.03 1.91c2.41 1.27 5.13 2.16 8.12 2.61 1.75.27 3.59.39 5.5.37 1.83-.03 3.6-.19 5.27-.49 3.2-.56 6.08-1.62 8.59-3.13z"
        fill={accent}
      />
      <path
        d="m195.58 162.265c.1-.59.14-1.21.13-1.87s-.07-1.3-.19-1.89c-.68-3.52-3.16-5.66-6.61-6.18-.59-.09-1.2-.13-1.84-.12s-1.31.07-1.92.18c-3.43.62-5.85 2.83-6.44 6.34-.1.59-.15 1.23-.14 1.89s.07 1.28.19 1.87c.68 3.5 3.16 5.64 6.61 6.16.61.09 1.25.14 1.92.13s1.25-.07 1.84-.17c3.44-.61 5.86-2.82 6.44-6.35z"
        fill={accent}
      />
      <path
        d="m140.66 76.8245c.28-1.68.41-3.47.38-5.36-.03-1.92-.21-3.72-.54-5.42-1.96-10.09-9.07-16.23-18.95-17.7-1.69-.25-3.45-.37-5.29-.34s-3.75.2-5.49.52c-9.84 1.78-16.77 8.1-18.45 18.18-.28 1.7-.42 3.52-.39 5.43s.21 3.67.53 5.35c1.95 10.02 9.05 16.16 18.95 17.67 1.75.27 3.59.39 5.5.37 1.83-.03 3.6-.19 5.27-.49 9.85-1.74 16.8-8.09 18.46-18.21z"
        fill={gray}
      />
      <path
        d="m130.75 90.1646c.2-11.21-5.47-15.38-14.14-15.23-8.14.14-13.53 4.51-13.34 15.71l.03 1.91c2.41 1.27 5.13 2.16 8.12 2.61 1.75.27 3.59.39 5.5.37 1.83-.03 3.6-.19 5.27-.49 3.2-.56 6.08-1.62 8.59-3.13z"
        fill={accent}
      />
      <path
        d="m124.86 66.9843c.1-.59.14-1.2099.13-1.8699s-.07-1.3-.19-1.89c-.68-3.52-3.16-5.66-6.61-6.18-.59-.09-1.2-.13-1.84-.12s-1.31.07-1.92.18c-3.43.62-5.85 2.8299-6.44 6.3399-.1.59-.15 1.2301-.14 1.8901s.07 1.28.19 1.87c.68 3.5 3.16 5.64 6.61 6.16.61.09 1.25.14 1.92.13s1.25-.07 1.84-.17c3.44-.61 5.86-2.82 6.44-6.35z"
        fill={accent}
      />
      <path
        d="m225.67 90.2845c.28-1.68.41-3.47.38-5.36s-.21-3.72-.54-5.42c-1.96-10.09-9.07-16.23-18.95-17.7-1.69-.25-3.45-.37-5.29-.34-1.91.03-3.75.2-5.49.52-9.84 1.78-16.77 8.1-18.45 18.18-.28 1.7-.42 3.52-.39 5.43.03 1.89.21 3.67.53 5.35 1.95 10.0195 9.05 16.1595 18.95 17.6695 1.75.27 3.59.39 5.5.37 1.83-.03 3.6-.19 5.27-.49 9.85-1.74 16.8-8.09 18.46-18.2095z"
        fill={accent}
      />
      <path
        d="m215.76 103.625c.2-11.2105-5.47-15.3805-14.14-15.2305-8.14.14-13.53 4.51-13.34 15.7105l.03 1.91c2.41 1.27 5.13 2.16 8.12 2.61 1.75.27 3.59.39 5.5.37 1.83-.03 3.6-.19 5.27-.49 3.2-.56 6.08-1.62 8.59-3.13z"
        fill={gray}
      />
      <path
        d="m209.87 80.4443c.1-.59.14-1.21.13-1.87s-.07-1.3-.19-1.89c-.68-3.52-3.16-5.66-6.61-6.18-.59-.09-1.2-.13-1.84-.12s-1.31.07-1.92.18c-3.43.62-5.85 2.83-6.44 6.34-.1.59-.15 1.23-.14 1.89s.07 1.28.19 1.87c.68 3.5 3.16 5.64 6.61 6.16.61.09 1.25.14 1.92.13s1.25-.07 1.84-.17c3.44-.61 5.86-2.82 6.44-6.35z"
        fill={gray}
      />
      <path
        d="m49 224.005s64.83 7.71 98.2-.35v-117.41s-52.91 12.96-98.2-.7c0 0 .72 118.98 0 118.46z"
        fill={gray}
      />
      <g stroke={stroke} strokeMiterlimit="10" strokeWidth="7">
        <path d="m62.9 145.154h70.41" />
        <path d="m62.9 162.404h70.41" />
        <path d="m62.9 179.654h70.41" />
        <path d="m62.9 196.904h70.41" />
      </g>
      <path
        d="m129.34 125.214c-3.3-2.92-8.33-2.61-11.24.69l-4.53 5.13 11.9 10.59 4.57-5.17c2.92-3.29 2.61-8.33-.69-11.24z"
        fill={blue}
      />
      <path
        d="m108.78 136.434-20.85 23.57v.01l-7.76 20.79 19.69-10.24 20.85-23.57z"
        fill={blue}
      />
      <path d="m82.94 173.375-2.77 7.43 7.03-3.66z" fill={blue} />
    </svg>
  );
}

export default AllCanEdit;
